import React, { useEffect, useState, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SecBTN from "../../../UI/SecBTN";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from "./Table.module.css";
import Modals from "../../../UI/Modals/Modals";
import Input from "../../../UI/Input/Input";
import Toast from "../../../UI/Toast/Toast";
import * as XLSX from "xlsx"; 
import jsPDF from "jspdf"; 
import "jspdf-autotable"; 
import { toast } from "react-toastify";
import { linkReplaceFn } from "../../../utils/custom_funtions";
import userService from "../../../app/services/user.service";

const DataTable = (props) => {
  const [showEntries, setShowEntries] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showBulkEditPopUp, setShowBulkEditPopUp] = useState(false);
  const [showBulkDeletePopUp, setShowBulkDeletePopUp] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Qdata, setData] = useState([]);



  const ITEMS_PER_PAGE = +showEntries;

  // Detect if data has paper_id to optionally add a sortable column
  // const hasPaperId = Array.isArray(props.data) && props.data.some(item => item && item.paper_id !== undefined);

  // Add checkbox column to headers and optional Paper ID column

  const headers = [
    { name: "Select", field: "select", sortable: false },
    ...props.headerdata.map(item => item)
  ];

  useEffect(() => {
    // Only for solution_link
    if (props.type !== "solution_link") return;
    
  
    // Empty search → don't call API
    if (!search) return;
    
  
    // Only numeric (paper_id)
    if (isNaN(search)) return;
    
  
    setLoading(true);
  
    const payload = {
      searchValue: Number(search),
    };
  
    userService.getVideoLinkData(payload)
      .then((res) => {
        setData(res.data.question_data); // or setData if local
        setLoading(false);
        console.log("res",res.data.question_data)
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  
  }, [search, props?.type]);
  
  const commentsData = useMemo(() => {
    //let computedComments = comments;
    let computedComments = props?.type === "solution_link" ? (Qdata || []) : (props.data || []);

    if (search) {
      const searchTerm = search.toLowerCase();

      computedComments = computedComments?.filter((comment) => {
        const isNumericSearch = !isNaN(search);

        // If search is numeric, match qid or paper_id exactly
        if (isNumericSearch) {
          const asInt = parseInt(search, 10);
          const matchesQid = comment.qid === asInt;
          const matchesPaperId = comment.paper_id === asInt;
          return matchesQid || matchesPaperId;
        }
        // Text search across relevant fields, include paper_id string match
        const paperIdStr = comment.paper_id !== undefined ? String(comment.paper_id) : "";
        return (
          comment.q_text?.toLowerCase().includes(searchTerm) ||
          // comment.qid?.toLowerCase().includes(searchTerm) ||
          comment.excersie_type?.toLowerCase().includes(searchTerm)   ||
          comment.topic_name?.toLowerCase().includes(searchTerm)  ||
          comment.target?.toLowerCase().includes(searchTerm) ||
          comment.batch?.toLowerCase().includes(searchTerm)  ||
          comment.type?.toLowerCase().includes(searchTerm)   ||
          paperIdStr.toLowerCase().includes(searchTerm)
        );
      });

      console.log(computedComments);
    }

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      const field = sorting.field;
      computedComments = computedComments?.sort((a, b) => {
        const av = a[field];
        const bv = b[field];
        // Numeric-safe sorting for numbers like paper_id; fallback to string compare
        if (typeof av === 'number' && typeof bv === 'number') {
          return reversed * (av - bv);
        }
        const as = av?.toString()?.toLowerCase?.() ?? '';
        const bs = bv?.toString()?.toLowerCase?.() ?? '';
        return reversed * as.localeCompare(bs);
      });
    }

    setTotalItems(computedComments?.length);

    //Do pagination
    return computedComments?.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [props?.data, Qdata, props?.type, currentPage, search, sorting, ITEMS_PER_PAGE]);

  //functions other than table
  const [dataToModal, setDataToModal] = useState({
    "id": "",
    "qid": "",
    "video_id": "",
    'video_cript_id':"",
    
  });
  
  const [index, setIndex] = useState(null);
  const [showPopUp, setShowPopUp] = useState(false);
  
  // Handle checkbox selection for individual rows
  const handleRowSelect = (id, item) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter(rowId => rowId !== id));
      setSelectedItems(selectedItems.filter(selectedItem => 
        (selectedItem.id || selectedItem.QID || selectedItem.topic_id) !== id
      ));
    } else {
      setSelectedRows([...selectedRows, id]);
      setSelectedItems([...selectedItems, item]);
    }
  };

  // Handle select all checkbox
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
      setSelectedItems([]);
    } else {
      const allRowIds = commentsData.map(row => row.id || row.QID || row.topic_id);
      setSelectedRows(allRowIds);
      setSelectedItems([...commentsData]);
    }
    setSelectAll(!selectAll);
  };

  // Open bulk edit modal
  const openBulkEditModal = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one row to edit");
      return;
    }
    setShowBulkEditPopUp(true);
  };

  // Open bulk delete confirmation modal
  const openBulkDeleteModal = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one row to delete");
      return;
    }
    setShowBulkDeletePopUp(true);
  };

  // Handle bulk edit save
  const onBulkEditSave = () => {
    const bulkData = selectedItems.map(item => {
      const id = item.id;
      const qid = item.qid || item.qid === 0 ? item.qid : item.qid; // fallback if needed
      const videoId = document.getElementById(`video_id_${id}`)?.value || item.vedio_id;
  
      return {
        id,
        video_id: videoId,
        qid
      };
    });
  
    const ids = bulkData.map(item => item.id).join(',');
    const video_ids = bulkData.map(item => item.video_id).join(',');
    const qids = bulkData.map(item => item.qid).join(',');
  
    const payload = {
      exercise_ids:ids,
      video_ids,
      qids,
      user_id: 1  // Replace with dynamic user_id if applicable
    };
  
    userService.bulkUpdateHandler(payload)
      .then(res => {
        toast.success("Bulk Question Updated Successfully");
      })
      .catch(err => {
        toast.error("Failed to update questions");
      });
  
    setShowBulkEditPopUp(false);
    setSelectedRows([]);
    setSelectedItems([]);
    setSelectAll(false);
  };
  
  

  // Handle bulk delete
  const onBulkDelete = () => {
    console.log(selectedRows);
  
    // Extract only the `id` values
    const exerciseIds = selectedRows.join(',');

    console.log(exerciseIds)
  
    // Create payload object
    const payload = {
      exercise_ids: exerciseIds
    };
  
    userService.bulkDeleteHandler(payload)
      .then(res => {
        toast.success("Bulk Question Deleted Successfully");
      })
      .catch(err => {
        toast.error("Failed to delete questions");
      });
  
    // Reset selection state
    setShowBulkDeletePopUp(false);
    setSelectedRows([]);
    setSelectedItems([]);
    setSelectAll(false);
  };
  

  const onSaveHandler = () => {
    console.log(dataToModal)
    const payload = {
      exercise_ids:dataToModal.id,
      video_ids:dataToModal.video_id,
      qids:dataToModal.qid,
      user_id: 1  // Replace with dynamic user_id if applicable
    };
  
    userService.bulkUpdateHandler(payload)
      .then(res => {
        toast.success(" Question Updated Successfully");
      })
      .catch(err => {
        toast.error("Failed to update question");
      });
    setShowPopUp(false);
  };
  
  const hideHandler = () => {
    setShowPopUp(false);
  };
  
  const hideBulkEditHandler = () => {
    setShowBulkEditPopUp(false);
  };

  const hideBulkDeleteHandler = () => {
    setShowBulkDeletePopUp(false);
  };

  const editHandler = (id, qid, video_id,video_cript_id) => {
    setDataToModal(() => {
      return {
        id: String(id),
        qid: String(qid),
        video_id:String(video_id),
        video_cript_id:String(video_cript_id)
       
      };
    });
    setShowPopUp(true);
    setIndex(index);
  };

  const copyToClipboard = () => {
    const headers = ["QID", "q_text", "sequence", "name", "topic", "target", "session", "batch", "type"];
  
    const dataToCopy = [
      headers.join('\t'), 
      ...props.data.map(item =>
        [
          item.QID,
          item.q_text,
          item.sequence,
          item.name,
          item.topic,
          item.target,
          item.session,
          item.batch,
          item.type
        ].join('\t') 
      )
    ].join('\n'); 
  
    // Copy the string to the clipboard
    navigator.clipboard.writeText(dataToCopy)
      .then(() => {
        toast.success("Data Copy to clipboard");
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  };

  const exportToExcel = () => {
    let data = [];
  
    switch (props.type) {
      case "exercise":
        data = props.data?.map((item, index) => {
          let formattedQText = item.q_text;
  
          if (formattedQText) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = linkReplaceFn(formattedQText);
            formattedQText = tempDiv.textContent || tempDiv.innerText;
          }
  
          return {
            SrNo: index + 1,
            QID: item.qid,
            Question: formattedQText,
            Sequence: item.sequence,
            Name: item.name,
            Topic: item.topic,
            Target: item.target,
            Session: item.session,
            Batch: item.batch,
            Type: item.type,
          };
        });
        break;
  
      case "dpp":
        data = props.data?.map((item, index) => {
          let formattedQText = item.q_text;
  
          if (formattedQText) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = linkReplaceFn(formattedQText);
            formattedQText = tempDiv.textContent || tempDiv.innerText;
          }
  
          return {
            SrNo: index + 1,
            QID: item.qid,
            Question: formattedQText,
            Sequence: item.question_sequence,
            ExerciseType: item.excersie_type,
            Topic: item.topic_name,
            Target: item.target,
            Session: item.session,
            VideoID: item.vedio_id,
          };
        });
        break;
  
      case "solution_link":
        data = Qdata?.map((item, index) => ({
          SrNo: index + 1,
          QID: item.qid,
          Subject: item.sub_name,
          Section: item.sec_id,
          DisplayNo: item.display_number,
          VideoLink: item.video_cript_id,
        }));
        break;
  
      case "solution_list":
        data = props.data?.map((item, index) => {
          let formattedQText = item.q_text;
  
          if (formattedQText) {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = linkReplaceFn(formattedQText);
            formattedQText = tempDiv.textContent || tempDiv.innerText;
          }
  
          return {
            SrNo: index + 1,
            QID: item.qid,
            Question: formattedQText,
            Link: item.link,
            VideoLink: item.video_cript_link,
          };
        });
        break;
  
      default:
        console.error("Unknown type provided");
    }
  
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
  
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "data_export.xlsx");
  };

  const exportToCSV = () => {
    const headers = ["QID", "q_text", "sequence", "name", "topic", "target", "session", "batch", "type"];
  
    // Convert data to CSV format
    const csvData = [
      headers.join(','), // Join the headers with commas
      ...props.data.map(item =>
        [
          item.QID,
          item.q_text,
          item.sequence,
          item.name,
          item.topic,
          item.target,
          item.session,
          item.batch,
          item.type
        ].join(',')
      )
    ].join('\n');
  
    // Create a Blob object and download the CSV file
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'data_export.csv';
    link.click();
  };

  // Export to PDF function
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Data Export", 14, 16);
  
    const header = [headers.slice(1).map(item => item['name'])]; // Skip checkbox column
    
    let data = [];
  
    // Handle different conditions based on props.type
    switch (props.type) {
      case "exercise":
        data = props.data?.map((item, index) => {
          // Apply linkReplaceFn to q_text and convert to plain text
          let formattedQText = item.q_text;
          if (formattedQText) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = linkReplaceFn(formattedQText);
            formattedQText = tempDiv.textContent || tempDiv.innerText;
          }
          
          return [
            index + 1,
            item.qid,
            formattedQText,
            item.question_sequence,
            item.excersie_type,
            item.topic_name,
            item.target,
            item.session,
            item.batch,
            item.type
          ];
        });
        break;
  
      case "dpp":
        data = props.data?.map((item, index) => {
          // Apply linkReplaceFn to q_text and convert to plain text
          let formattedQText = item.q_text;
          if (formattedQText) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = linkReplaceFn(formattedQText);
            formattedQText = tempDiv.textContent || tempDiv.innerText;
          }
          
          return [
            index + 1,
            item.qid,
            formattedQText,
            item.question_sequence,
            item.excersie_type,
            item.topic_name,
            item.target,
            item.session,
            item.vedio_id
          ];
        });
        break;
  
      case "solution_link":
        data = props.data?.map((item, index) => [
          index + 1,
          item.qid,
          item.subject,
          item.section,
          item.display_no,
          // item.link, 
          item.video_cript_link 
        ]);
        break;
  
      case "solution_list": 
        data = props.data?.map((item, index) => {
          // Apply linkReplaceFn to q_text and convert to plain text
          let formattedQText = item.q_text;
          if (formattedQText) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = linkReplaceFn(formattedQText);
            formattedQText = tempDiv.textContent || tempDiv.innerText;
          }
          
          return [
            index + 1,
            item.qid,
            formattedQText,
            item.link,
            item.video_cript_link,
          ];
        });
        break;
  
      default:
        console.error("Unknown type provided");
    }
  
    doc.autoTable({
      head: header,
      body: data,
      startY: 10,
    });
  
    doc.save("data_export.pdf");
  };
  
  return (
    <>
      <Toast />
      {/* Individual Edit Modal */}
      <Modals show={showPopUp} onHide={hideHandler}>
        <Row className="g-3">
          <h5>Edit Question & video id</h5>
          <Col sm={12}>
            <Form.Label>Edit Question id:</Form.Label>
            <Input
              value={dataToModal.id || dataToModal.video_id}
              type="number"
              placeholder="Question id"
              onChange={(e) =>
                setDataToModal((prev) => {
                  return { ...prev, id: e.target.value };
                })
              }
            />
          </Col>
          <Col sm={12}>
            <Form.Label>Video id :</Form.Label>
            <Input
              value={dataToModal.video_id ? dataToModal.video_id : dataToModal.video_cript_id}
              type="number"
              placeholder="Video ID"
              onChange={(e) =>
                setDataToModal((prev) => {
                  return { ...prev, video_id: e.target.value };
                })
              }
            />
          </Col>
        </Row>
        <div className="text-center mt-5 mb-3">
          <SecBTN className="sec-btn1" onClick={onSaveHandler}>
            Save Changes
          </SecBTN>
        </div>
      </Modals>

      {/* Bulk Edit Modal */}
      <Modals show={showBulkEditPopUp} onHide={hideBulkEditHandler}>
        <Row className="g-3">
          <h5>Bulk Edit Selected Items ({selectedRows.length})</h5>
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {selectedItems.map((item, idx) => {
              const itemId = item.id || item.QID || item.topic_id;
              return (
                <div key={idx} className="mb-4 p-3" style={{ border: '1px solid #ddd', borderRadius: '5px' }}>
                  <h6>Item {idx + 1}: ID {itemId}</h6>
                  <Row className="g-3">
                    <Col sm={12}>
                      <Form.Label>Question ID:</Form.Label>
                      <Input
                        id={`question_id_${item.qid}`}
                        type="number"
                        placeholder="Question ID"
                        defaultValue={ item.qid || ''}
                      />
                    </Col>
                    <Col sm={12}>
                      <Form.Label>Video ID:</Form.Label>
                      <Input
                        id={`video_id_${itemId}`}
                        type="number"
                        placeholder="Video ID"
                        defaultValue={item.topic_sequence || item.vedio_id || item.video_cript_id || ''}
                      />
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
        </Row>
        <div className="text-center mt-5 mb-3">
          <SecBTN className="sec-btn1" onClick={onBulkEditSave}>
            Save Bulk Changes
          </SecBTN>
        </div>
      </Modals>

      {/* Bulk Delete Confirmation Modal */}
      <Modals show={showBulkDeletePopUp} onHide={hideBulkDeleteHandler}>
        <Row className="g-3">
          <h5>Delete Selected Items</h5>
          <p>Are you sure you want to delete {selectedRows.length} selected items?</p>
        </Row>
        <div className="text-center mt-5 mb-3">
          <SecBTN className="sec-btn" style={{ backgroundColor: "#dc3545", marginRight: "10px" }} onClick={onBulkDelete}>
            Confirm Delete
          </SecBTN>
          <SecBTN className="sec-btn" onClick={hideBulkDeleteHandler}>
            Cancel
          </SecBTN>
        </div>
      </Modals>

      {(props.data?.length == 0 && props.type !== "solution_link" ) ? (
        props.noDataShow ? (
          <p>No data Found !!</p>
        ) : (
          <p>Please Select Subject!!</p>
        )
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div>
              Show{" "}
              <select
                onChange={(e) => {
                  setShowEntries(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
              </select>{" "}
              enteries {"  "}
              <SecBTN className={'sec-btn btn2'} onClick={copyToClipboard}>Copy</SecBTN>
              <SecBTN className="sec-btn btn2" onClick={exportToExcel}>
                Excel
              </SecBTN>
              <SecBTN className="sec-btn btn2" onClick={exportToPDF}>
                PDF
              </SecBTN>
              <SecBTN className={'sec-btn btn2'} onClick={exportToCSV}>CSV</SecBTN>
              
              {/* Always show bulk operation buttons */}
              { props.type==="dpp"?
              <SecBTN 
                className="sec-btn1"
                // style={{ marginLeft: "10px", backgroundColor: "#28a745" }}
                onClick={openBulkEditModal}
              >
                Bulk Edit {selectedRows.length > 0 ? `(${selectedRows.length})` : ''}
              </SecBTN>
              :
              ""
             }
             { (props.type==="dpp" || props.type==="exercise") ?
              <SecBTN 
                className="sec-btn1"
                style={{ marginLeft: "10px" }}
                onClick={openBulkDeleteModal}
              >
                Bulk Delete {selectedRows.length > 0 ? `(${selectedRows.length})` : ''}
              </SecBTN>
              : ""
             }
            </div>
            <div>
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  props.setSearchvalue(value);


                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered mt-3 mb-0">
              <TableHeader
                className={classes.header}
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData?.map((data, index) => {
                  // Determine the ID for this row
                  const rowId = data.id || data.QID || data.paper_id;
                  return (
                  <tr key={index}>
                    {/* Checkbox column */}
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={selectedRows.includes(rowId)}
                        onChange={() => handleRowSelect(rowId, data)}
                      />
                    </td>
                    {props.type=="exercise" &&
                    <>
                    <th scope="row">{index+1}</th>
                    <td>{data.qid}</td>
                    {/* {hasPaperId && <td>{data.paper_id}</td>} */}
                    <td><p
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(data.q_text),
                                }}
                              /></td>
                    <td>{data.question_sequence}</td>
                    <td>{data.excersie_type}</td>
                    <td>{data.topic_name}</td>
                    <td>{data.target}</td>
                    <td>{data.session}</td>
                    <td>{data.batch}</td>
                    <td>{data.type}</td>
                    </>
                    }

                    {props.type=="dpp" &&
                    <>
                    <th scope="row">{index+1}</th>
                    <td>{data.qid}</td>
                    {/* {hasPaperId && <td>{data.paper_id}</td>} */}
                    <td><p
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(data.q_text),
                                }}
                              /></td>
                    <td>{data.question_sequence}</td>
                    <td>{data.excersie_type}</td>
                    <td>{data.topic_name}</td>
                    <td>{data.target}</td>
                    <td>{data.session}</td>
                    <td>{data.vedio_id}</td>
                    </>
                    }

                    {props.type=="solution_link" &&
                    <>
                    <th scope="row">{index+1}</th>
                    <td>{data.qid}</td>
                    {/* {hasPaperId && <td>{data.paper_id}</td>} */}
                    <td>{data.sub_name}</td>
                    <td>{data.sec_id}</td>
                    <td>{data.display_number}</td>
                    {/* <td>{data.link}</td> */}
                    <td>{data.video_cript_id}</td>
                    </>
                    }

                    {props.type=="solution_list" &&
                    <>
                    <th scope="row">{index+1}</th>
                    <td>{data.qid}</td>
                    {/* {hasPaperId && <td>{data.paper_id}</td>} */}
                    <td><p
                                dangerouslySetInnerHTML={{
                                  __html: linkReplaceFn(data.q_text),
                                }}
                              /></td>
                    <td>{data.link}</td>
                    <td>{data.video_cript_id}</td>
                    </>
                    }
                    <td>
                      <SecBTN
                        className="sec-btn"
                        style={{ padding: "0.3rem 1rem", fontSize: "0.8rem" }}
                        onClick={() =>
                          editHandler(
                            data.id,
                            data.qid,
                            data.vedio_id,
                            data.video_cript_id,
                          )
                        }
                      >
                        Edit
                      </SecBTN>
                    </td>
                  </tr>
                )})}
              </tbody>
            </table>
          </div>
          <p className="small ">
            Showing{" "}
            <b>
              {+showEntries < props.data?.length
                ? +showEntries
                : props.data?.length}
            </b>{" "}
            out of {props.data?.length} enteries
          </p>
          <div className="mt-4">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </>
      )}
    </>
  );
};

export default DataTable;